@if (labelLocations?.length) {
    <div class="d-flex flex-wrap">
        <!-- Margin top negative to offset for the mt-2 for the display label which is required when the labels wrap -->
        @for (labelLocation of labelLocations; track labelLocation) {
            <adapt-display-label class="me-1"
                                 [label]="labelLocation.label"
                                 [adaptLinkDisabled]="linkDisabled"></adapt-display-label>
        }
    </div>
} @else {
    @if (labels?.length) {
        <div class="d-flex flex-wrap">
            @for (label of labels; track label) {
                <adapt-display-label class="me-1"
                                     [label]="label"
                                     [adaptLinkDisabled]="linkDisabled"
                                     data-test="labels-display"></adapt-display-label>
            }
        </div>
    }
}
